/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

if (document.getElementById('FAQContent')) {
    $tabContents = $('#FAQ__tab-content');
    $navContent = $('#FAQ__nav-tabs');
    $tabContents.find('.faq-section').hide();

    $html_titles = '';
    $tabContents.find('.faq-section').each(function(i) {
      let id = $(this).attr('id');
      let title = $(this).find('.FAQ__section').data('title');
      if(title) $html_titles += '<li><a class="FAQ__nav-trigger" href="#" data-toggle="#'+id+'">'+title+'</a></li>'
    });
    $navContent.html($html_titles);

    $navContent.on('click', '.FAQ__nav-trigger', function(e) {
      e.preventDefault();
      let id = $(this).data('toggle');
      
      $tabContents.find('.faq-section').hide();
      $(id).show();
      
      $navContent.find('li').removeClass('active');
      $(this).parent().addClass('active');

      $('.FAQ__answer').hide();
      $('.FAQ__default-msg').show();
    });

    $navContent.find('li:first-child .FAQ__nav-trigger').click();
    
    $('.FAQ__question').on('click', function(e) {
      e.preventDefault();
      let answer = $(this).attr('aria-controls');
      $('.FAQ__answer').hide();
      $('#'+answer).slideDown();
      $('.FAQ__question').removeClass('active');
      $(this).addClass('active');
    })
}